import {connect} from 'react-redux'
import {updateResource, createResource} from 'redux-json-api'
import Categories from './Categories'
import {cleanResponse} from '../../../../../lib/apiHelpers'
import {Map} from 'immutable'


const EverplanDetails = ({loading, ...otherProps}) => {
  if (loading) {
    return null
  } else {
    return (
      <div className='everplan-details' data-testid='everplan-details'>
        <Categories {...otherProps} actor='pro' context='pro_client_dashboard' />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  categories: state.categories,
  everplanBundleDownload: cleanResponse(state.api['everplan-bundle-downloads'])?.last() || Map(),
  kits: state.kits,
  listMappings: state.listMappings,
  views: state.views
})

export default connect(mapStateToProps, {updateResource, createResource})(EverplanDetails)
